// AppProviders.tsx
/**
 * The root provider stack. Extracted from App.tsx (F3).
 *
 * Order matters: ActiveInstitutionProvider needs auth to know the user's
 * memberships, InstitutionConfigProvider resolves its config (and brand CSS
 * variables) from the active institution, and AppProvider's user sync reads
 * both.
 */

import type { ReactNode } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { AppProvider } from './contexts/AppContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { MobileProvider } from './contexts/MobileContext';
import { ConfirmProvider } from './contexts/ConfirmContext';
import { InstitutionConfigProvider } from './contexts/InstitutionConfigContext';
import { ActiveInstitutionProvider } from './contexts/ActiveInstitutionContext';

export interface AppProvidersProps {
  children: ReactNode;
}

const AppProviders = ({ children }: AppProvidersProps) => (
  <ThemeProvider>
    <MobileProvider>
      <AuthProvider>
        <ActiveInstitutionProvider>
          <InstitutionConfigProvider>
            <AppProvider>
              <ConfirmProvider>{children}</ConfirmProvider>
            </AppProvider>
          </InstitutionConfigProvider>
        </ActiveInstitutionProvider>
      </AuthProvider>
    </MobileProvider>
  </ThemeProvider>
);

export default AppProviders;
